(function(angular, jQuery){
    'use strict';

    angular.module('onvio.setup.client.notifications').controller('onvio.setup.client.notifications.WordingController', wordingController);
    wordingController.$inject = [
        '$q',
        '$rootScope',
        '$scope',
        '$timeout',
        '$translate',
        '$uibModal',
        'onvio.setup.client.notifications.WordingCategory',
        'bmtClientNotificationsStylingManager',
        'messageFactory',
        'NotificationTemplate',
        'bmUtil',
        'bluemoon.components.Notifications',
        'bmLanguageManager',
        'languageStorageManager',
        '$http'
    ];

    function wordingController($q, $rootScope, $scope, $timeout, $translate, $uibModal, WordingCategory, stylingManager, messageFactory, NotificationTemplate, bmUtil, Notifications, bmLanguageManager, languageStorageManager, $http){
        /*jshint validthis:true */
        var vm = this;
        var templates = {};
        var defaultTemplates = {};
        var templateVariables = {};
        var fieldStates = {};
        var emailAddresses = {};
        var typeDirtyStates = {};
        var apiEnvironment = 'external';

        vm.alerts = [];
        vm.selectedFieldState = {};
        vm.isValidTemplate = true;
        vm.saveTemplate = saveTemplate;
        vm.sendTest = sendTest;
        vm.restoreDefault = restoreDefault;
        vm.resetTemplate = resetTemplate;
        vm.setSelectedType = setSelectedType;
        vm.onGlobalChange = onGlobalChange;
        vm.getNameForUserLocale = getNameForUserLocale;
        vm.getDescriptionForUserLocal = getDescriptionForUserLocal;
        vm.setSyncCategoryMap = setSyncCategoryMap;
        vm.toggleDisableDirectNotifications = toggleDisableDirectNotifications;
        vm.toggleDisableMobileNotifications = toggleDisableMobileNotifications;
        vm.toggleDisableEmailNotifications = toggleDisableEmailNotifications;

        // setup froala options and create dynamic dropdown object for froala
        var imageUploadApi = messageFactory.getImagesApiForEnvironment(apiEnvironment);
        var onvioHeaders = {};
        var tokenType = 'UDSLongToken';
        var token = bmUtil.cookie(tokenType);
        var froalaImages = [];
        var dropdownSetup = {};
        var dropdownButton = 'wordingVariables-';
        var userLanguage = 'en-US';
        var notAvailable = 'Not Available';
        var syncNotificationType;
        var categorySyncList = {};

        vm.froalaOptions = {};
        vm.variableOptions = {};

        if(token){
            onvioHeaders.Authorization = tokenType + ' ' + token;
        }

        $scope.$watch('vm.language.selected', function(newValue, oldValue){
            // save off dirty state of currently selected type if loaded already
            if(oldValue && vm.localCategories && vm.selectedType){
                trackTypeDirtyState(vm.selectedType.categoryCode, vm.selectedType.id, isAlreadyDirty(vm.selectedType.categoryCode, vm.selectedType.id) || vm.wordingSetupForm.$dirty);
            }

            initView();
        });

        $scope.$watch('vm.categories', function(){
            initView();
        });

        // listen for selected type change for keeping tree selections in sync
        $rootScope.$on('notificationTemplateChanged', function(evt, args){
            // language that threw the event?
            if(args.language.code === vm.language.code){
                return;
            }

            syncNotificationType = args.type;
            categorySyncList = args.categories;
        });

        // listen for tree expanded change for keeping tree selections in sync
        $rootScope.$on('notificationCategoryChanged', function(evt, args){
            // language that threw the event?
            if(args.language.code === vm.language.code){
                return;
            }

            categorySyncList = args.categories;
        });

        $translate([
            'onvio.setup.notifications.useMobileTooltip',
            'onvio.setup.notifications.useGlobalTooltip',
            'onvio.setup.notifications.disableEmailTooltip',
            'onvio.setup.notifications.disableDirectTooltip',
            'onvio.setup.notifications.notAvailable',
            'bmt.notifications.type.variables',
            'onvio.setup.notifications.disableMobileTooltip'
        ]).then(function(l10n) {
            vm.useMobileToolTip = l10n['onvio.setup.notifications.useMobileTooltip'];
            vm.useGlobalToolTip = l10n['onvio.setup.notifications.useGlobalTooltip'];
            vm.disableEmailToolTipText = l10n['onvio.setup.notifications.disableEmailTooltip'];
            vm.disableDirectToolTipText = l10n['onvio.setup.notifications.disableDirectTooltip'];
            notAvailable = l10n['onvio.setup.notifications.notAvailable'];
            vm.variables = l10n['bmt.notifications.type.variables'];
            vm.disableMobileToolTipText = l10n['onvio.setup.notifications.disableMobileTooltip'];
        });

        bmLanguageManager.getLoadedLanguageAsync().then(function(language){
            userLanguage = language.code;
        });

        ///////////

        function initView(){
            if(angular.isDefined(vm.language)){
                // expose method through 2-way databinding
                vm.language.setTabDirtyDisplay = function(){
                    // save off dirty state of current selected item
                    var isTypeDirty = isAlreadyDirty(vm.selectedType.categoryCode, vm.selectedType.id) || vm.wordingSetupForm.$dirty;
                    trackTypeDirtyState(vm.selectedType.categoryCode, vm.selectedType.id, isTypeDirty);
                    vm.selectedType.isDirty = isTypeDirty;
                };
            }

            // Is the data loaded on the control yet?
            if(angular.isUndefined(vm.categories) || angular.isUndefined(vm.language) || !vm.language.selected){
                return;
            }

            if(vm.categories.length === 0){
                // TODO: HANDLE NO DATA DISPLAY
                return;
            }

            // complete the setup of froala now that language is available
            dropdownButton += vm.language.code;

            dropdownSetup[dropdownButton] = {
                title: vm.variables,
                icon: {
                    type: 'font',
                    value: 'fa fa-tags'
                },
                options: vm.variableOptions
            };

            // set the froala options
            vm.froalaOptions = getFroalaOptions();

            // already loaded the list of local categories
            if(vm.localCategories){
                var syncType;
                var syncCategory;

                // reset display of isDirty flag for types
                angular.forEach(vm.localCategories, function(category){
                    setIsDirtyForTypes(category.types);

                    if(angular.isDefined(syncNotificationType)){
                        // find the type to sync
                        if(syncNotificationType.categoryCode === category.code){
                            syncCategory = category;
                            syncType = getNotificationTypeFromCategory(category, syncNotificationType.id);
                        }
                    }

                    // keep categories expanded across tabs
                    category.open = angular.isDefined(categorySyncList) ? categorySyncList[category.id] : false;
                });

                // keep the same selected type across tabs
                if(angular.isDefined(syncType)){
                    setSelectedType(syncType, true);
                }

                // reset the sync notification
                syncNotificationType = undefined;
                return;
            }

            // setup the list of categories and selected type
            var localCategories = {};
            var hasAtleastOne = false;

            // sort the list based on user language
            vm.categories.sort(sortByNames);

            for(var i = 0; i < vm.categories.length; i++){
                var category = vm.categories[i];

                // avoid duplicate categories
                if(localCategories[category.id]){
                    continue;
                }

                if(category.types){
                    // does the category have any public types?
                    var filteredTypes = category.types.filter(function(typeElement){
                        return typeElement.visible;
                    });

                    if(filteredTypes.length > 0){
                        // sort the type list based on user language
                        filteredTypes.sort(sortByNames);

                        setIsDirtyForTypes(filteredTypes);

                        // only keep the public types
                        category.types = filteredTypes;

                        // keep categories expanded across tabs
                        category.open = angular.isDefined(categorySyncList) ? categorySyncList[category.id] : false;

                        // use sync type if defined to keep tree on same template between languages
                        if(angular.isDefined(syncNotificationType)){
                            if(category.code === syncNotificationType.categoryCode){
                                setSelectedType(getNotificationTypeFromCategory(category, syncNotificationType.id), true);
                            }
                        } else if(angular.isUndefined(vm.selectedType)){
                            // select the first type of the open category by default
                            category.open = true;
                            setSelectedType(category.types[0], false);
                        }

                        hasAtleastOne = true;
                        localCategories[category.id] = new WordingCategory(category);
                    }
                }

                // update the sync list just in case
                categorySyncList[category.id] = category.open;
            }

            // reset the sync notification
            syncNotificationType = undefined;

            if(!hasAtleastOne){
                // TODO: HANDLE SOME SORT OF ERROR MESSAGE DISPLAY OF NO CATEGORIES
                return;
            }

            vm.localCategories = localCategories;
        }

        function getNotificationTypeFromCategory(category, typeId){
            var returnNotification;

            for(var i = 0;i < category.types.length;i++){
                if(category.types[i].id === typeId){
                    returnNotification = category.types[i];
                    break;
                }
            }

            return returnNotification;
        }

        function sortByNames(first, second){
            var firstName = getNameForUserLocale(first.names);
            var secondName = getNameForUserLocale(second.names);

            if (firstName > secondName) {
                return 1;
            }

            if (firstName < secondName) {
                return -1;
            }

            // equal names
            return 0;
        }

        function setSelectedType(notificationType, emitChange){
            // track dirty state for current selected type before setting new selected type
            if(vm.selectedType){
                var isTypeDirty = isAlreadyDirty(vm.selectedType.categoryCode, vm.selectedType.id) || vm.wordingSetupForm.$dirty;
                trackTypeDirtyState(vm.selectedType.categoryCode, vm.selectedType.id, isTypeDirty);
                vm.selectedType.isDirty = isTypeDirty;
            }

            // reset the form and any errors
            resetAlerts();
            vm.wordingSetupForm.$setPristine();

            // set the new selected type
            vm.selectedType = notificationType;
            loadTemplateForSelectedType().then(function(loaded){
                // only load up variables if not already cached
                if(loaded === 'api'){
                    loadTemplateVariablesForSelectedTemplate();
                }
            });

            if(emitChange){
                $rootScope.$emit('notificationTemplateChanged', {
                    language: vm.language,
                    type: angular.copy(vm.selectedType),
                    categories: categorySyncList
                });
            }
        }

        function setSyncCategoryMap(category){
            category.open = !category.open;
            categorySyncList[category.id] = category.open;

            $rootScope.$emit('notificationCategoryChanged', {
                language: vm.language,
                categories: categorySyncList
            });
        }

        function loadTemplateForSelectedType(){
            // already loaded?
            if(templates[vm.selectedType.code] && defaultTemplates[vm.selectedType.code] && templateVariables[vm.selectedType.code]){
                var deferred = $q.defer();

                vm.selectedTemplate = templates[vm.selectedType.code];
                vm.selectedFieldState = angular.isDefined(fieldStates[vm.selectedType.code]) ?
                    fieldStates[vm.selectedType.code] : getFieldStateForTemplate(vm.selectedTemplate, defaultTemplates[vm.selectedType.code]);

                setVariablesAsOptions(templateVariables[vm.selectedType.code]);
                deferred.resolve('memory');
                return deferred.promise;
            }

            // load template for selected type
            return messageFactory.getTemplatesForType(vm.selectedType.categoryCode, vm.selectedType.code, vm.language.code, apiEnvironment).then(function(templateData){
                vm.selectedTemplate = new NotificationTemplate(templateData.template);
                if (templateData.template.digestChannels) {
                    vm.selectedTemplate.digestChannels = templateData.template.digestChannels;
                } else if (templateData.defaultTemplate.digestChannels) {
                    vm.selectedTemplate.digestChannels = templateData.defaultTemplate.digestChannels;
                } else {
                    vm.selectedTemplate.digestChannels = [{channel: 'email', frequency: 'OFF'}];
                }

                // if they just Restored Defaults, vm.selectedTemplate.id will be blank
                // we want digestChannel[0].id to be blank as well, so the backend can assign new ids upon save
                if ((angular.isUndefined(vm.selectedTemplate.id) || vm.selectedTemplate.id.length === 0) &&
                    angular.isDefined(vm.selectedTemplate.digestChannels[0].id)){
                    vm.selectedTemplate.digestChannels[0].id = null;
                }

                templates[vm.selectedType.code] = vm.selectedTemplate;
                defaultTemplates[vm.selectedType.code] = new NotificationTemplate(templateData.defaultTemplate);
                vm.selectedFieldState = getFieldStateForTemplate(vm.selectedTemplate, defaultTemplates[vm.selectedType.code]);
                // set the email addresses display if global
                if(vm.selectedFieldState.showGlobalToggle && vm.selectedFieldState.useGlobal){
                    setGlobalAddresses();
                }

                return 'api';
            });
        }

        function loadTemplateVariablesForSelectedTemplate(){
                setVariablesDisplay(vm.selectedTemplate.type.variables);
                var deferred = $q.defer();
                deferred.resolve();
                return deferred.promise;
        }

        function setVariablesDisplay(variables){
            if(angular.isUndefined(variables) || variables.length === 0){
                return;
            }

            var variableStore = [];
            angular.forEach(variables, function(variable){
                if(angular.isDefined(variable.names) && variable.names.length > 0){
                    var displayNames = variable.names.filter(function(name){
                        return (name.locale === vm.language.code);
                    });

                    // always fallback to en-US
                    if(angular.isUndefined(displayNames) || displayNames.length === 0 || angular.isUndefined(displayNames[0].name)){
                        displayNames = variable.names.filter(function(name){
                            return (name.locale === 'en-US');
                        });
                    }

                    if(angular.isDefined(displayNames) && displayNames.length === 1 && angular.isDefined(displayNames[0].name)){
                        variableStore.push(displayNames[0].name);
                    }
                }
            });

            templateVariables[vm.selectedType.code] = variableStore;
            setVariablesAsOptions(variableStore);
        }

        function getFieldStateForTemplate(template, defaultTemplate){
            if(angular.isUndefined(template) || angular.isUndefined(defaultTemplate) || angular.isUndefined(template.type)){
                // TODO: PROBABLY NEED SOME SORT OF DEFAULT FIELD STATE HERE
                return {};
            }

            // fields are disabled for user entry if the type is disabled
            // don't display Add CC or Add BCC if values are already assigned in the template

            // default template controls enable, disable, hide and show
            // firm template only controls the state of the global toggle and whether the cc and bcc fields are hidden or show initially
            var templateType = template.type;
            var state = {
                showDirect: defaultTemplate.sendDirect || !templateType.disableDirectChannel,
                showMobile: defaultTemplate.sendMobile || !templateType.disableMobileChannel,
                showEmail: defaultTemplate.sendEmail || !templateType.disableEmailChannel,
                showGlobalToggle: defaultTemplate.useGlobal || !templateType.disableUseGlobal,
                globalDisabled: defaultTemplate.useGlobal && templateType.disableUseGlobal,
                directTextDisabled: templateType.disableDirectChannel,
                mobileTextDisabled: templateType.disableMobileChannel,
                hideSenderName: templateType.disableSenderName && (angular.isUndefined(defaultTemplate.senderName) || defaultTemplate.senderName === ''),
                hideSenderEmail: templateType.disableSenderEmail && (angular.isUndefined(defaultTemplate.senderEmail) || defaultTemplate.senderEmail === ''),
                hideCc: templateType.disableCC && (angular.isUndefined(defaultTemplate.cc) || defaultTemplate.cc === ''),
                hideBcc: templateType.disableBCC && (angular.isUndefined(defaultTemplate.bcc) || defaultTemplate.bcc === ''),
                hideSubject: templateType.disableSubjectLine && (angular.isUndefined(defaultTemplate.channels[0].subject) || defaultTemplate.channels[0].subject === ''),
                subjectTextDisabled: templateType.disableSubjectLine,
                hideBody: templateType.disableBody && (angular.isUndefined(defaultTemplate.channels[0].body) || defaultTemplate.channels[0].body === ''),
                bodyTextDisabled: templateType.disableBody,
                useGlobal: template.useGlobal,
                displayCcRow: angular.isDefined(template.cc) && template.cc !== '',
                displayBccRow: angular.isDefined(template.bcc) && template.bcc !== ''
            };

            // separate enabled state for global toggle
            state = getEmailFieldEnabledState(state, templateType);

            // store state for reload of template
            fieldStates[template.type.code] = state;

            return state;
        }

        function getEmailFieldEnabledState(viewState, templateType){
            viewState.senderNameTextDisabled = templateType.disableSenderName || viewState.useGlobal;
            viewState.senderEmailTextDisabled = templateType.disableSenderEmail || viewState.useGlobal;
            viewState.ccTextDisabled = templateType.disableCC || viewState.useGlobal;
            viewState.bccTextDisabled = templateType.disableBCC || viewState.useGlobal;
            return viewState;
        }

        function getNameForUserLocale(names){
            if(angular.isUndefined(names) || names.length === 0){
                return notAvailable;
            }

            var name;

            for(var i = 0; i < names.length; i++){
                if(names[i].locale === userLanguage){
                    name = names[i].name;
                    break;
                }
            }

            return angular.isDefined(name) && name !== '' ? name : notAvailable;
        }

        function getDescriptionForUserLocal(names){
            if(angular.isUndefined(names) || names.length === 0){
                return notAvailable;
            }

            var description;

            for(var i = 0; i < names.length; i++){
                if(names[i].locale === userLanguage){
                    description = names[i].description;
                    break;
                }
            }

            return angular.isDefined(description) && description !== '' ? description : notAvailable;
        }

        function onGlobalChange(value){
            // update the current loaded state
            var state = fieldStates[vm.selectedTemplate.type.code];
            state.useGlobal = value;
            state = getEmailFieldEnabledState(state, vm.selectedTemplate.type);
            vm.selectedFieldState = state;

            // set the template to use value
            vm.selectedTemplate.useGlobal = value;

            // set form dirty state for tracking unsaved changes
            vm.wordingSetupForm.$setDirty();

            // load up global settings and set values for fields
            if(value){
                setGlobalAddresses();
            } else if(emailAddresses[vm.selectedTemplate.type.code]){
                // restore original values before selecting globals
                setEmailFieldValues(vm.selectedTemplate, angular.copy(emailAddresses[vm.selectedTemplate.type.code]));

                // remove any stored values
                delete emailAddresses[vm.selectedTemplate.type.code];
            }
        }

        function setGlobalAddresses(){
            // TODO: MAY NEED TO DOUBLE CHECK THAT THERE ARE GLOBAL SETTINGS TO USE?
            stylingManager.getLocalePreferences(apiEnvironment, vm.language.code).then(function(results){
                var preferences = (angular.isDefined(results) && angular.isDefined(results.defaultPreferences)) ? results.preferences : results;

                // save off current values for restoring on useGlobal change
                emailAddresses[vm.selectedTemplate.type.code] = {
                    senderName: angular.copy(vm.selectedTemplate.senderName),
                    senderEmail: angular.copy(vm.selectedTemplate.senderEmail),
                    cc: angular.copy(vm.selectedTemplate.cc),
                    bcc: angular.copy(vm.selectedTemplate.bcc)
                };

                setEmailFieldValues(vm.selectedTemplate, preferences);
            }, function(){
                // reset to not use global
                vm.selectedFieldState.useGlobal = false;
                vm.selectedTemplate.useGlobal = false;
            });
        }

        function setEmailFieldValues(template, preferences){
            if(angular.isDefined(template) && angular.isDefined(preferences)){
                template.senderName = preferences.senderName;
                template.senderEmail = preferences.senderEmail;
                template.cc = preferences.cc;
                template.bcc = preferences.bcc;
            }
        }

        function setIsDirtyForTypes(notificationTypes){
            if(angular.isUndefined(notificationTypes) || notificationTypes.length === 0){
                return;
            }

            // set the dirty flag on the types for the selected language
            for(var j = 0; j < notificationTypes.length; j++){
                notificationTypes[j].isDirty = isAlreadyDirty(notificationTypes[j].categoryCode, notificationTypes[j].id);
            }
        }

        function trackTypeDirtyState(categoryCode, typeId, isDirty){
            if(angular.isUndefined(typeDirtyStates[categoryCode])){
                typeDirtyStates[categoryCode] = {};
            }

            var dirtyState = typeDirtyStates[categoryCode];

            // add the type to the dirty list
            if(isDirty){
                dirtyState[typeId] = true;
            } else {
                // clear the dirty state
                delete dirtyState[typeId];
            }

            // set dirty state for categories based on dirty state of types
            setCategoriesDirty();
        }

        function isAlreadyDirty(categoryCode, typeId){
            var dirtyState = typeDirtyStates[categoryCode];

            if(dirtyState && dirtyState[typeId]){
                return dirtyState[typeId];
            }

            return false;
        }

        function setCategoriesDirty(){
            if(vm.language){
                vm.language.hasUnsavedTypes = false;
            }

            if(angular.isUndefined(vm.localCategories) || vm.localCategories.length === 0){
                return;
            }

            angular.forEach(vm.localCategories, function(category){
                category.isDirty = isCategoryDirty(category.code);

                if(category.isDirty){
                    vm.language.hasUnsavedTypes = true;
                }
            });
        }

        function isCategoryDirty(categoryCode){
            if(angular.isUndefined(typeDirtyStates) || angular.isUndefined(typeDirtyStates[categoryCode])){
                return false;
            }

            var obj = typeDirtyStates[categoryCode];
            var keys = Object.keys(obj);

            // if any keys exist in type dirty states then the category is dirty
            return angular.isDefined(keys) && keys.length > 0;
        }

        function saveTemplate(template){
            // TODO: REMEMBER TO DELETE UPLOADED IMAGES THAT AREN'T USED
            // TODO: MAY NEED TO DOUBLE CHECK THAT THERE ARE GLOBAL SETTINGS TO USE?
            resetAlerts();

            // invalid form?
            // template provided if restoring default
            if(angular.isUndefined(template) && !getFormFieldValidity()){
                $translate('onvio.setup.common.invalidForm').then(function(value){
                    vm.alerts.push({ msg: value, type: 'danger' });
                });
                $scope.$emit('scollViewTop');
                return;
            }

            var templateToSave = angular.isDefined(template) ? template : angular.copy(vm.selectedTemplate);

            // set environment for using the correct api call
            templateToSave.environment = apiEnvironment;

            // don't actually overwrite the template email address values on save if global is set
            if(templateToSave.useGlobal && emailAddresses[templateToSave.type.code]){
                setEmailFieldValues(templateToSave, emailAddresses[templateToSave.type.code]);
            }

            $rootScope.$emit('bm-busy-loading-on');
            return templateToSave.save().then(function(){
                trackTypeDirtyState(vm.selectedType.categoryCode, vm.selectedType.id, false);
                vm.selectedType.isDirty = false;
                vm.wordingSetupForm.$setPristine();

                $rootScope.$emit('bm-busy-loading-off');
                $translate('onvio.setup.notifications.templates.saveSuccessful').then(function(value){
                    Notifications.setSuccess(value);
                });
            }, function(){
                $rootScope.$emit('bm-busy-loading-off');
                $translate('onvio.setup.notifications.templates.saveError').then(function(value){
                    Notifications.setError(value);
                });
            });
        }

        function sendTest(){
            // make sure a disabled button doesn't cause action
            if(!vm.isValidTemplate){
                return;
            }

            // set environment for using the correct api call
            vm.selectedTemplate.environment = apiEnvironment;

            vm.selectedTemplate.sendTest().then(function(){
                $translate('onvio.setup.notifications.templates.sendTestSuccessful').then(function(value){
                    Notifications.setSuccess(value);
                });
            }, function(){
                $translate('onvio.setup.notifications.templates.sendTestError').then(function(value){
                    Notifications.setError(value);
                });
            });
        }

        function restoreDefault(){
            var modalInstance = $uibModal.open({
                templateUrl: 'components/client-notifications/styling/restore-default-modal.2js.html',
                controller: 'restoreDefaultStylingCtrl as vm',
                backdrop: 'static',
                size: 'sm'
            });

            modalInstance.result.then(function(){
                var defaultTemplate = defaultTemplates[vm.selectedType.code];

                // is there a default or is this already the default
                if(angular.isUndefined(defaultTemplate) || angular.isUndefined(vm.selectedTemplate.id) || vm.selectedTemplate.id === ''){
                    resetTemplate();
                    return;
                }

                deleteTemplate(vm.selectedTemplate.id).then(function() {
                    // reload all the template data
                    delete emailAddresses[vm.selectedType.code];
                    delete templates[vm.selectedType.code];
                    delete defaultTemplates[vm.selectedType.code];
                    delete fieldStates[vm.selectedType.code];
                    loadTemplateForSelectedType();
                    $rootScope.$emit('scollViewTop');
                });
            });
        }

        function deleteTemplate(id) {
            return $http({
                method: 'DELETE',
                url: '/api/notifications/v1/templates/' + id
            });
        }

        function resetTemplate(){
            delete templates[vm.selectedType.code];
            trackTypeDirtyState(vm.selectedType.categoryCode, vm.selectedType.id, false);
            vm.selectedType.isDirty = false;
            resetAlerts();
            vm.wordingSetupForm.$setPristine();
            loadTemplateForSelectedType();
            $rootScope.$emit('scollViewTop');
        }

        function toggleDisableDirectNotifications(value) {
            vm.selectedTemplate.sendDirect = value;
        }

        function toggleDisableMobileNotifications(value) {
            vm.selectedTemplate.sendMobile = value;
        }

        function toggleDisableEmailNotifications(value) {
            vm.selectedTemplate.sendEmail = value;
        }

        function getFroalaOptions(){
            // Setup options for wysiwyg
            return {
                language: languageStorageManager.get(),
                imageUpload: true,
                imageUploadURL: imageUploadApi,
                imageDeleteConfirmation: false,
                headers: onvioHeaders,
                inlineMode: false,
                spellcheck: true,
                pasteImage: false,
                fullPage: true,
                useClasses: false,
                placeholder: '',
                buttons: [
                    'bold', 'italic', 'underline', 'fontFamily','fontSize', 'color', 'sep', 'formatBlock', 'align',
                    'insertUnorderedList', 'insertOrderedList', 'indent', 'outdent', 'sep', 'createLink', 'insertLinkButton',
                    'insertImage', 'insertHorizontalRule', 'undo', 'redo', 'html', dropdownButton
                ],
                beautifyCode: false,
                allowScript: true,
                minHeight: 150,
                maxHeight: 500,
                tabSpaces: false,
                customDropdowns: dropdownSetup,
                events: {
                    afterRemoveImage: function(e, editor, img){
                        var src = img.attr('src');
                        var parts = src.split('/');
                        froalaImages.push(parts[parts.length - 1]);
                    },
                    afterImageUpload: function(e, editor, response){
                        if(response.link){
                            var parts = response.link.split('/');
                            froalaImages.push(parts[parts.length - 1]);
                        }
                    }
                }
            };
        }

        function setVariablesAsOptions(variables){
            if(angular.isUndefined(variables) || variables.length === 0){
                return;
            }

            // clear the options without creating a new object
            clearObject(vm.variableOptions);

            angular.forEach(variables, function(variable, i){
                vm.variableOptions[variable] = function() {
                  variable = templateVariables[vm.selectedType.code][i];
                  this.insertHTML('[' + variable + ']');
                  this.sync();
                };
              });

            // update the html of the variable dropdown list
            $timeout(function(){
                // TODO - KMS - NotificationRework - should we be calling .RegisterCommand instead of .buildCustomDropdown now?
                // https://www.froala.com/wysiwyg-editor/v2.0/docs/migrate-from-v1
                // resort to jQuery to dynamically add html elements build up the custom custom dropdown html
                var dropdown = jQuery(jQuery.Editable.prototype.buildCustomDropdown(vm.froalaOptions.customDropdowns[dropdownButton], dropdownButton));
                jQuery('#wording_' + vm.language.code + '_froala div.fr-bttn.fr-dropdown:last').html(dropdown.html());
            }, 0);
        }

        // TODO: THIS REALLY NEEDS TO BE A GLOBAL UTILITY
        function clearObject(vartoClear){
            // clear out old object properties without changing object reference
            for (var variableKey in vartoClear){
                if (vartoClear.hasOwnProperty(variableKey)){
                    delete vartoClear[variableKey];
                }
            }
        }

        function resetAlerts(){
            vm.alerts = [];
        }

        function getFormFieldValidity(){
            // set form as dirty in order to display any validation messages
            vm.wordingSetupForm.$setSubmitted();
            return vm.wordingSetupForm.$valid;
        }
    }
})(window.angular, window.jQuery);
